type OptionBase<T> = {
    label: string;
    value: T;
};

export function convertValuesToOptions<Value, OptionType extends OptionBase<Value>>(
    values: Value[],
    options: OptionType[]
) {
    const selectedOptions = values.reduce<OptionType[]>((result, key) => {
        const foundOption = options.find(option => {
            if (option.value === key) {
                return true;
            }
            return false;
        });

        if (foundOption) {
            result.push(foundOption);
        }
        return result;
    }, []);
    return selectedOptions;
}
